import React from 'react';
import { Box as RebassBox } from 'rebass';

/**
 * `forwardRef` written in a `.js` file infers no props at all — the component
 * comes out as `RefAttributes<any>`, so every prop a caller passes is an error.
 * This is a pure passthrough, so the props are exactly Rebass's own.
 *
 * @type {React.ForwardRefExoticComponent<import('rebass').BoxProps>}
 */
export const Box = React.forwardRef((props, ref) => (
  <RebassBox ref={ref} {...props} />
));
